<template>
  <div class="content">
    <report-filter :reload-report="reloadReport" :loading="loading"/>

    <div class="col-md-8 ml-auto mr-auto">
      <h3 class="text-center">{{ $t('canceledSeasonTicketsReport.title') }}</h3>
      <p class="text-center mb-3 no-print">
        {{ $t('canceledSeasonTicketsReport.description') }}
      </p>
    </div>

    <div v-if="loading" v-loading="loading" class="row pt-5"/>

    <div v-if="loading === false && error" class="row mt-3">
      <div class="col-12">
        <base-alert type="danger">
          <strong>{{ $t(`generic.errorTitle`) }}</strong> {{ error }}
        </base-alert>
      </div>
    </div>

    <div v-if="loading === false && !error && reportData" class="row">
      <div class="col-6">
        <card :title="$t('canceledSeasonTicketsReport.summary.title')">
          <table>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('canceledSeasonTicketsReport.summary.generatedAt') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.generated_at | time }}</h5></td>
            </tr>
            <tr>
              <td><h5 class="p-0 m-1">{{ $t('canceledSeasonTicketsReport.summary.reportingPeriod') }}:</h5></td>
              <td><h5 class="p-0 m-1 font-weight-bold text-muted">{{ reportData.from | dateOnly }} - {{
                  reportData.to | dateOnly
                }}</h5></td>
            </tr>
          </table>
        </card>
      </div>
    </div>


    <div v-if="loading === false && !error && reportData" class="row mt-3">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`canceledSeasonTicketsReport.refundedTableTitle`) }}
            <small v-if="reportData" class="ml-2 text-muted">({{ reportData.from | dateOnly }} - {{
                reportData.to | dateOnly
              }})</small></h4>
          <el-table :data="reportData.refunded" :empty-text="$t('generic.emptyReportForThePeriod')"
                    show-summary :summary-method="getCanceledSeasonTicketsTableTotal">
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.season_ticket_id')">
              <template slot-scope="{ row }">{{ row.season_ticket_id }}</template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.start_month')">
              <template slot-scope="{ row }">{{ row.start_year }}-{{ row.start_month }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.price')">
              <template slot-scope="{ row }">{{ row.price | money }}</template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.count')">
              <template slot-scope="{ row }">{{ row.count }}</template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.refundedPriceSum')">
              <template slot-scope="{ row }">{{ row.count * row.price | money }}</template>
            </el-table-column>
          </el-table>
        </card>
      </div>

      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t(`canceledSeasonTicketsReport.revokedTableTitle`) }}
            <small v-if="reportData" class="ml-2 text-muted">({{ reportData.from | dateOnly }} - {{
                reportData.to | dateOnly
              }})</small></h4>
          <el-table :data="reportData.revoked" :empty-text="$t('generic.emptyReportForThePeriod')"
                    show-summary :summary-method="getCanceledSeasonTicketsTableTotal">
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.season_ticket_id')">
              <template slot-scope="{ row }">{{ row.season_ticket_id }}</template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.start_month')">
              <template slot-scope="{ row }">{{ row.start_year }}-{{ row.start_month }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.price')">
              <template slot-scope="{ row }">{{ row.price | money }}</template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.count')">
              <template slot-scope="{ row }">{{ row.count }}</template>
            </el-table-column>
            <el-table-column :label="$t('canceledSeasonTicketsReport.table.priceSum')">
              <template slot-scope="{ row }">{{ row.count * row.price | money }}</template>
            </el-table-column>
          </el-table>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import {BaseAlert} from 'src/components';
import ReportFilter from "./ReportFilter";
import {mapActions, mapState} from "vuex";

export default {
  name: 'refunded_season_tickets_report',
  components: {
    BaseAlert,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    ReportFilter
  },
  computed: {
    ...mapState({
      loading: state => state.canceled_season_tickets_report.loading,
      reportData: state => state.canceled_season_tickets_report.reportData,
      error: state => state.canceled_season_tickets_report.error,
    }),
  },
  methods: {
    ...mapActions(['GetCanceledSeasonTicketsReport']),
    reloadReport(query) {
      this.GetCanceledSeasonTicketsReport(query);
    },
    getCanceledSeasonTicketsTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t('canceledSeasonTicketsReport.table.totalSum');
          return;
        }
        if (index === 3 || index === 4) {
          let values;
          if (index === 3) {
            values = data.map(item => Number(item.count));
          } else if (index === 4) {
            values = data.map(item => Number(item.count * item.price));
          }

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }

          if (index === 4) {
            sums[index] = this.$options.filters['money'](sums[index])
          }

        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
};
</script>

